import { Card, Descriptions, Divider, Space } from 'antd';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { TPersonData } from 'app/railways/domains/passengers/core/person';
import { AccountStatusLabel } from 'app/railways/domains/passengers/ui/account-status-label';
import { PhoneStatusLabel } from 'app/railways/domains/passengers/ui/phone-status-label';
import { appRoute } from 'app/railways/router/routes';

type DetailsPersonProps = {
  person: TPersonData;
};

export const DetailsPerson = observer(({ person }: DetailsPersonProps) => {
  const personProfilePath = appRoute.PERSON.DETAILS.buildPath({
    passengerId: person.id,
  });

  return (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <Card size="small" title="Общее">
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item
            label="Профиль"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            <AccountStatusLabel status={person.accountStatus} />
            <Divider type="vertical" />
            <Link to={personProfilePath}>Открыть профиль</Link>
            <Divider type="vertical" />
            ID: {person.id}
          </Descriptions.Item>
          <Descriptions.Item
            label="Номер телефона"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            {' '}
            <PhoneStatusLabel status={person.phoneStatus} />
            <Divider type="vertical" />
            {person.phone}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
});
